var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7734 61.9843C12.7669 60.2332 1.76389 49.2302 0.0146709 35.2272C-0.122428 34.1454 0.722813 33.1853 1.81718 33.1853H9.1602C10.0472 33.1853 10.803 33.8257 10.9521 34.6986C12.3642 43.0617 18.9337 49.633 27.3022 51.0469C28.175 51.1959 28.8155 51.9517 28.8155 52.8387V60.1818C28.8153 61.2622 27.8787 62.1158 26.7734 61.9843Z",
    fill: "#43463B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16067 29.0674H1.81765C0.722681 29.0674 -0.121832 28.1067 0.0151454 27.0254C1.93828 11.619 15.1022 0.000488281 30.6326 0.000488281C37.5321 0.000488281 44.0733 2.25002 49.5498 6.50614C50.4209 7.1857 50.4861 8.45992 49.7201 9.22583L44.5291 14.4186C43.901 15.0484 42.9147 15.1265 42.1908 14.6137C38.7827 12.185 34.7857 10.9006 30.6325 10.9006C20.859 10.9006 12.581 17.9047 10.9524 27.5541C10.8034 28.4268 10.0477 29.0674 9.16067 29.0674Z",
    fill: "#43463B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9332 60.1835V52.8405C32.9332 51.9534 33.5736 51.1977 34.4465 51.0486C44.0958 49.42 51.1 41.142 51.1 31.3685C51.1 27.2153 49.8156 23.2183 47.3868 19.8102C46.8723 19.0881 46.9539 18.0982 47.5819 17.4719L52.7747 12.2809C53.5308 11.5248 54.809 11.5728 55.4944 12.4512C59.7505 17.9279 62 24.469 62 31.3684C62 46.8988 50.3814 60.0627 34.9751 61.9859C33.8579 62.1191 32.9332 61.2513 32.9332 60.1835Z",
    fill: "#43463B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7286 23.7386C23.7286 22.7353 22.9152 21.9219 21.912 21.9219H18.2786C17.2753 21.9219 16.4619 22.7353 16.4619 23.7386V38.272C16.4619 39.2753 17.2753 40.0887 18.2786 40.0887H21.912C22.9152 40.0887 23.7286 39.2753 23.7286 38.272V23.7386Z",
    fill: "#7A7F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6287 38.272V20.1052C34.6287 19.1019 33.8153 18.2885 32.812 18.2885H29.1787C28.1754 18.2885 27.362 19.1019 27.362 20.1052V38.272C27.362 39.2753 28.1754 40.0887 29.1787 40.0887H32.812C33.8155 40.0887 34.6287 39.2753 34.6287 38.272Z",
    fill: "#43463B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5288 38.272V31.0053C45.5288 30.002 44.7154 29.1886 43.7121 29.1886H40.0788C39.0755 29.1886 38.2621 30.002 38.2621 31.0053V38.272C38.2621 39.2753 39.0755 40.0887 40.0788 40.0887H43.7121C44.7155 40.0887 45.5288 39.2753 45.5288 38.272Z",
    fill: "#91928D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiLogo);
export default __webpack_public_path__ + "static/media/fi_logo.c70cb45489c5c83f3c4438ad3c29536f.svg";
export { ForwardRef as ReactComponent };